import Component, { getInitialProps } from "../../treasures/[id]/[collection]"

const Collection = (props) => {
	return <Component {...props} />
}

Collection.getInitialProps = getInitialProps
export default Collection
